import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import styled from 'styled-components'

// Components
import NavContainer from '../components/Nav'
import TravelMap from '../components/TravelMap'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0; left: 0;
  right: 0; bottom: 0;
`;

const TextContainer = styled.div`
  position: absolute;
  z-index: 10;

  h1 {
    margin-bottom: .2em;
  }
`;

const SmallPrint = styled.span`
  font-size: .8em;
  // text-align: center;
`;

const WherePage = () => (
  <PageContainer>
    <TextContainer>
      <h1>Vienna, Austria</h1>
      <SmallPrint>I love to work, kite, and travel the globe.</SmallPrint>
    </TextContainer>

    <TravelMap />

    <NavContainer>
      <Link to={`/what`} activeClassName="active">what</Link>
      <Link to={`/who`} activeClassName="active">who</Link>
      <Link to={`/where`} activeClassName="active">where</Link>
      {/*<Link to={`/when`} activeClassName="active">when</Link>*/}
      <Link to={`/why`} activeClassName="active">why</Link>
    </NavContainer>
  </PageContainer>
)

export default WherePage


// WEBPACK FOOTER //
// ./src/pages/where.js